export default "__VITE_ASSET__CgN5p5qE__"